var exports = {
  "kL": "xfd349460--70963f--container",
  "AS": "xfd349460--70963f--item",
  "JL": "xfd349460--70963f--faq",
  "qI": "xfd349460--70963f--value-wrapper",
};

module.exports = exports;
